module.exports = __webpack_public_path__ + "img/account-summary-pricing-white.8a83be44.svg";